import React from 'react';
import { Users, MessageSquare, Calendar } from 'lucide-react';
import { TimeRange, UserStatsResponse } from '../../../../../types/admin';
import { AdminCard } from '../../../ui';

interface StatItemProps {
  label: string;
  value: number;
  icon: React.ReactNode;
}

const StatItem: React.FC<StatItemProps> = ({ label, value, icon }) => (
  <div className="flex flex-col items-center gap-1 p-4 bg-[#1a1a1a] rounded-lg text-center hover:-translate-y-0.5 transition-transform">
    <div className="text-[#F4CC04] mb-2">
      {icon}
    </div>
    <span className="text-[#888888] text-sm">{label}</span>
    <span className="text-white text-2xl font-medium">{value.toLocaleString()}</span>
  </div>
);

interface DashboardStatsProps {
  stats: UserStatsResponse | null;
  selectedTimeRange: TimeRange;
  onTimeRangeChange: (range: TimeRange) => void;
}

const TIME_RANGE_OPTIONS = [
  { value: TimeRange.DAY, label: 'Últimas 24 horas' },
  { value: TimeRange.WEEK, label: 'Última semana' },
  { value: TimeRange.MONTH, label: 'Último mês' },
  { value: TimeRange.THREE_MONTHS, label: 'Últimos 3 meses' },
  { value: TimeRange.ALL, label: 'Todo período' },
];

export const DashboardStats: React.FC<DashboardStatsProps> = ({
  stats,
  selectedTimeRange,
  onTimeRangeChange,
}) => {
  return (
    <AdminCard>
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <h2 className="text-[#F4CC04] text-xl font-semibold">
          Estatísticas de Usuários
        </h2>
        <select
          value={selectedTimeRange}
          onChange={(e) => onTimeRangeChange(e.target.value as TimeRange)}
          className="
            px-4 py-2
            bg-[#1a1a1a] border border-[#333333]
            text-white
            rounded-lg
            focus:outline-none focus:border-[#F4CC04]
            cursor-pointer
            md:w-auto w-full
          "
        >
          {TIME_RANGE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StatItem
          label="Novos Usuários"
          value={stats?.new_users ?? 0}
          icon={<Users className="w-6 h-6" />}
        />
        <StatItem
          label="Novas Perguntas"
          value={stats?.new_questions ?? 0}
          icon={<MessageSquare className="w-6 h-6" />}
        />
        <StatItem
          label="Novas Sessões"
          value={stats?.new_sessions ?? 0}
          icon={<Calendar className="w-6 h-6" />}
        />
      </div>
    </AdminCard>
  );
};

export default DashboardStats;
